import { render, staticRenderFns } from "./RequestPriorityBadge.vue?vue&type=template&id=7d86184d"
import script from "./RequestPriorityBadge.vue?vue&type=script&lang=js"
export * from "./RequestPriorityBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports